import { useBundledProductPurchaseMotions } from '../../../../features/purchaseMotions/hooks/useBundledProductPurchaseMotions';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { useShouldShowTermToggleForMerchCard } from '../../../../hooks/useShouldShowTermSelectorForMerchCard';
import { useAppSelector } from '../../../../reducers';
import { getIsLatestVersionOfProductInProductInventorySelector } from '../../../../selectors/ProductInventorySelectors';
import { getIsTBSkuSelector, productSelector } from '../../../../selectors/ProductsSelectors';
import { productLineToSkuCategoryName } from '../../../../v2/constants';
import { useCurrentTrial } from '../../../../v2/hooks/badges/useActiveTrials';
import { useHasHigherProductLevelInProductInventory } from '../../../../v2/hooks/inventory/useHighestProductLevel';
export const useProductCardMetadata = ({
  apiName
}) => {
  const isAppReady = useGlobalLoading();
  const product = useAppSelector(state => {
    if (!isAppReady) return null;
    return productSelector(state, {
      apiName
    });
  });
  const skuId = product === null || product === void 0 ? void 0 : product.currentSkuId;
  const productLevel = product === null || product === void 0 ? void 0 : product.productLevel;
  const productLine = product === null || product === void 0 ? void 0 : product.productLine;
  const isCurrentPlanLevel = useAppSelector(state => isAppReady && apiName ? getIsLatestVersionOfProductInProductInventorySelector(state, {
    productIdentifier: {
      apiName
    }
  }) : false);
  const isCurrentTrial = useCurrentTrial(apiName);
  const shouldShowTermSelector = useShouldShowTermToggleForMerchCard(product);

  // CTAs Metadata
  const purchaseMotions = useBundledProductPurchaseMotions({
    skuId
  });
  const productSkuCategoryName = productLine ? productLineToSkuCategoryName[productLine] : undefined;
  const {
    hasHigherProductLevel: hasHigherTieredProduct
  } = useHasHigherProductLevelInProductInventory({
    productLevel,
    skuCategoryName: productSkuCategoryName
  });
  const isHubspotFree = apiName === 'hubspot-free';

  // Features Metadata
  const isSuiteProduct = useAppSelector(state => isAppReady && skuId ? getIsTBSkuSelector(state, {
    skuId
  }) : false);
  const shouldShowSuiteObjectives = (isHubspotFree || isSuiteProduct) && productLevel;
  return {
    skuId,
    productLevel,
    productLine,
    isCurrentPlanLevel,
    isCurrentTrial,
    shouldShowTermSelector,
    purchaseMotions,
    hasHigherTieredProduct,
    isHubspotFree,
    shouldShowSuiteObjectives
  };
};